package com.eladfinish.bible.contest.ui.components.toolbar.autohide

import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.constants.BooleanConstants
import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * The toolbar lives in the app's scaffold and the scrolling in a screen: a screen that hides the toolbar
 * while scrolling says so here, and shows it again when it leaves.
 */
class ToolbarAutoHide(
    private val settings: KeyValueSettings,
) {
    private val _transition = MutableStateFlow(SHOWN)
    internal val transition: StateFlow<ToolbarAutoHideTransition> = _transition.asStateFlow()

    /** The toolbar's height when shown, measured by [ToolbarAboveContent]. */
    internal var toolbarHeightPx = 0f

    fun isEnabled(): Boolean = settings.getBoolean(
        key = SharedPrefsConstants.KEY_HIDE_TOOLBAR_ON_SCROLL,
        defaultValue = BooleanConstants.ENABLE_HIDE_TOOLBAR_ON_SCROLL,
    )

    internal fun start(transition: ToolbarAutoHideTransition) {
        _transition.value = transition
    }

    private companion object {
        val SHOWN = ToolbarAutoHideTransition(
            isHidden = false,
            durationMs = 0,
            easing = ToolbarAutoHideEasing.SHOW_NEAR_TOP,
        )
    }
}
